import Cookie from "../src/cookie.js";
import { newTracker, trackPageView, setUserId, trackSelfDescribingEvent, addGlobalContexts } from "@snowplow/browser-tracker";
import { EcommercePlugin } from "@snowplow/browser-plugin-ecommerce";
import { setupTracking } from "kaleido-event-tracker";
import User from "@/modules/user";

const snowplowConfig = JSON.parse(document.querySelector("meta[property='snowplow']").getAttribute("content"));

if (snowplowConfig.enabled) {
  const pageViewsEndpoint = snowplowConfig.page_views_endpoint;
  const pageViewsIdentifier = snowplowConfig.page_views_identifier;

  newTracker(pageViewsIdentifier, pageViewsEndpoint, {
    appId: "remove.bg",
    platform: "web",
    anonymousTracking: !Cookie.consentGivenFor("performance"),
    eventMethod: "post",
    cookieLifetime: 2 * 365 * 24 * 60 * 60 * 1000,
    contexts: {
      webPage: true,
    },
  });

  const customEventsEndpoint = snowplowConfig.custom_events_endpoint;
  const customEventsIdentifier = snowplowConfig.custom_events_identifier;

  newTracker(customEventsIdentifier, customEventsEndpoint, {
    appId: "remove.bg",
    platform: "web",
    anonymousTracking: !Cookie.consentGivenFor("performance"),
    eventMethod: "post",
    cookieLifetime: 2 * 365 * 24 * 60 * 60 * 1000,
    contexts: {
      webPage: true,
    },
    plugins: [EcommercePlugin()],
  });

  const userEventsEndpoint = snowplowConfig.user_events_endpoint;
  const userEventsIdentifier = snowplowConfig.user_events_identifier;

  newTracker(userEventsIdentifier, userEventsEndpoint, {
    appId: "remove.bg",
    platform: "web",
    anonymousTracking: !Cookie.consentGivenFor("performance"),
    eventMethod: "post",
    cookieLifetime: 2 * 365 * 24 * 60 * 60 * 1000,
    contexts: {
      webPage: true,
    },
  });

  const contextEntity = {
    schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/context/rbg_global_context/jsonschema/1-0-1.json",
    data: {
      vcs_ref: snowplowConfig.vcs_ref,
      build_date: snowplowConfig.build_date,
      version: snowplowConfig.version,
      rbg_feature_flags: snowplowConfig.rbg_feature_flags,
      rbg_experiments: snowplowConfig.rbg_experiments,
      is_mobile_app: User.mobileApp(),
    },
  };

  const allTrackers = [pageViewsIdentifier, customEventsIdentifier, userEventsIdentifier];

  addGlobalContexts([contextEntity], allTrackers);
  setUserId(snowplowConfig.user_id, allTrackers);
  setupTracking(trackSelfDescribingEvent, [userEventsIdentifier], snowplowConfig.custom_events_enabled);

  const eventsEndpoint = snowplowConfig.events_endpoint;
  const eventsIdentifier = snowplowConfig.events_identifier;

  newTracker(eventsIdentifier, eventsEndpoint, {
    appId: "remove.bg",
    platform: "web",
    withCredentials: false,
    anonymousTracking: !Cookie.consentGivenFor("performance"),
    eventMethod: "post",
    cookieLifetime: 2 * 365 * 24 * 60 * 60 * 1000,
    contexts: {
      webPage: true,
    },
  });

  const context = {
    schema: "iglu:bg.remove/rbg_global_context/jsonschema/1-0-1",
    data: {
      vcs_ref: snowplowConfig.vcs_ref,
      build_date: snowplowConfig.build_date,
      version: snowplowConfig.version,
      rbg_feature_flags: snowplowConfig.rbg_feature_flags,
      rbg_experiments: snowplowConfig.rbg_experiments,
      is_mobile_app: User.mobileApp(),
    },
  };

  addGlobalContexts([context], [eventsIdentifier]);
  setUserId(snowplowConfig.user_id, [eventsIdentifier]);

  trackPageView({}, [pageViewsIdentifier, eventsIdentifier]);
} else {
  const noOpTracker = () => {};
  setupTracking(noOpTracker, [], false);
}
